import { useNextRouter } from "@/data/Content/_NextRouter";
import { getClientSideCommon } from "@/data/utils/getClientSideCommon";
import { customTransactionsSupplierData } from "integration/generated/customTransactions";
import { GetServerSidePropsContext } from "next";
import { useState } from "react";
import { STORE_ID } from "../config/STORE_ID";
import { getSettings, useSettings } from "../Settings";
import { ContentProps } from "@/data/types/ContentProps";
import { getProduct } from "@/data/Content/Product-Server";
import { findAttributeByIdentifier } from "@/utils/productAttributes";
import useSWR, { unstable_serialize } from "swr";
import { shrink } from "@/data/utils/keyUtil";
import { getServerSideCommon } from "@/data/utils/getServerSideCommon";
import { getServerCacheScope } from "@/data/cache/getServerCacheScope";
import { getUser } from "../User-Server";

const DATA_KEY = 'SUPPLIER_DATA_KEY';
export const supplierDataFetcher =
	(pub: boolean, context?: GetServerSidePropsContext): any =>
		async (
			storeId: string,
			catentryId:string
		) => {
			try {
				const suplierInfo = await customTransactionsSupplierData(pub).getSupplier(
					storeId,
					catentryId,
				); 
				
				return  suplierInfo;
			} catch (error: any) {
				return error;
			}
		};

export const getSupplierData = async ({ cache, id, context }: ContentProps) => {
	const partNumber = id.toString();
	let product = await getProduct(cache, partNumber, context);
	const  attrs = product?.attributes;
	const manuFacturerAttr = findAttributeByIdentifier(attrs, 'Manufacturer number');
	const supplierAttr = findAttributeByIdentifier(attrs, 'EUResponsible');
	if(manuFacturerAttr || supplierAttr){		
		const user = await getUser(cache, context);
		const settings = await getSettings(cache, context);
		const {
				storeId,
			} = getServerSideCommon(settings, context);
		const props = {
				storeId,
				catentryId:product?.id,				
			};
		const key = unstable_serialize([shrink(props), DATA_KEY]);
		const cacheScope = getServerCacheScope(context, user.context);
		const value =
			cache.get(key, cacheScope) ||
			supplierDataFetcher(false, context)(props, {});
		cache.set(key, value, cacheScope);
	}
}; 

export const useSupplierData = (catentryId:string) => {
	
	const router = useNextRouter();
	const { settings } = useSettings();
	const { storeId} = getClientSideCommon(settings, router);
	const props = {
				storeId,
				catentryId:catentryId,				
			};
	const { data } = useSWR(
		catentryId?[shrink({props}),DATA_KEY]:null, async()=>supplierDataFetcher(true)(storeId??STORE_ID, catentryId)
	); 	

	return {
		supplierData:data??""
	};
};